export default "__VITE_ASSET__C32Yw2oC__"